import styled from 'styled-components'
import { Heading } from 'pcln-design-system'

const StyledH6 = styled(Heading.h6)`
  font-weight: 900;
`

StyledH6.displayName = 'StyledH6'

const StyledH2 = styled(Heading.h2)`
  font-weight: 900;
`

StyledH2.displayName = 'StyledH2'

export { StyledH2, StyledH6 }
